<template>
  <BaseModal v-model="isOpen" title="Поддержка">
    <div class="text-center">
      <div class="mb-6">
        <h4 class="text-white text-lg mb-2">Электронная почта</h4>
        <a href="mailto:info@carddy.ru" class="text-[#09c6f8] hover:underline text-lg">info@carddy.ru</a>
      </div>
      
<!--      <div class="mb-6">-->
<!--        <h4 class="text-white text-lg mb-2">Telegram</h4>-->
<!--        <a -->
<!--          href="https://t.me/carddy_bot" -->
<!--          target="_blank" -->
<!--          rel="noopener noreferrer" -->
<!--          class="bg-[#0088cc] text-white px-6 py-3 rounded-full inline-flex items-center hover:bg-[#0077b5] transition-colors"-->
<!--        >-->
<!--          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">-->
<!--            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18.835-.68 2.869-1.283 5.215-.68 2.607-1.42 5.33-1.42 5.33s-.117.296-.532.296c-.18 0-.414-.089-.65-.266-.532-.414-1.065-.768-1.48-1.065-.828-.591-1.45-1.065-2.607-1.893-.71-.473-2.5-1.657-2.303-2.607.059-.296.65-1.42 2.303-2.607 1.42-1.065 3.254-2.13 3.9-2.487.118-.059.237-.118.355-.177.65-.296.71-.118.65.177-.059.65-1.657 1.657-2.607 2.487-.65.532-1.42 1.183-1.42 1.42 0 .059 0 .118.059.118.355.177 1.42.71 2.13 1.065 1.42.768 2.84 1.598 3.727 2.13.237.118.414.237.65.355.473.296.65.118.591-.296-.118-.71-.296-2.13-.296-2.84 0-.177.059-.414.118-.65.177-.532.414-1.065.532-1.598.296-.828.532-1.775.71-2.487.059-.355.177-.71.237-1.065.059-.177.118-.355.118-.532.059-.237.118-.414.118-.65.059-.118.059-.237.059-.355.059-.237-.118-.237-.355-.177z"/>-->
<!--          </svg>-->
<!--          Открыть Telegram бот-->
<!--        </a>-->
<!--      </div>-->
      
      <p class="text-gray-400 text-sm mt-4">
        Наша команда поддержки готова помочь вам с любыми вопросами по использованию сервиса Carddy.
      </p>
    </div>
  </BaseModal>
</template>

<script>
import { defineComponent, ref } from 'vue'
import BaseModal from '@/components/BaseModal.vue'

export default defineComponent({
  name: 'SupportModal',
  components: {
    BaseModal
  },
  setup() {
    const isOpen = ref(false)
    
    const openModal = () => {
      isOpen.value = true
    }
    
    const closeModal = () => {
      isOpen.value = false
    }
    
    return {
      isOpen,
      openModal,
      closeModal
    }
  }
})
</script>
